import { axiosAdmin } from './axios';
import { IRole, IRoleWithPositions, IRoleWithPositionsAndSkills } from '../interfaces/role';
import { ISkill } from '../interfaces/skills';
import { IPosition, IPositionWithSkills } from '../interfaces/position';

export namespace SkillsService {
  export function getSkills(positionId?: number): Promise<ISkill> {
    return axiosAdmin.get<ISkill>('/skills', { params: positionId || {} })
      .then(({ data }) => data);
  }

  export function getRoles(): Promise<IRole[]> {
    return axiosAdmin.get<IRole[]>('/roles').then(({ data }) => data);
  }

  export function getRolesWithPositions(): Promise<IRoleWithPositions[]> {
    return axiosAdmin.get<IRoleWithPositions[]>('/roles', { params: { includePositions: true, includeSkills: false } })
      .then(({ data }) => data);
  }

  export function getRolesWithPositionsAndSkills(): Promise<IRoleWithPositionsAndSkills[]> {
    return axiosAdmin.get<IRoleWithPositionsAndSkills[]>('/roles', { params: { includePositions: true, includeSkills: true } })
      .then(({ data }) => data);
  }

  export function getPositions(): Promise<IPosition[]> {
    return axiosAdmin.get<IPosition[]>('/positions').then(({ data }) => data);
  }
  
  export function getPositionsWithSkills(): Promise<IPositionWithSkills[]> {
    return axiosAdmin.get<IPositionWithSkills[]>('/positions', { params: { includeSkills: true } })
      .then(({ data }) => data);
  }

}